import isomorphicFetch from 'isomorphic-fetch';
import _ from 'lodash';
import { stringify } from 'qs';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}

function _toPrimitive(input, hint) {
  if (_typeof$1(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof$1(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof$1(key) === "symbol" ? key : String(key);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var regeneratorRuntimeExports = {};
var regeneratorRuntime$1 = {
  get exports(){ return regeneratorRuntimeExports; },
  set exports(v){ regeneratorRuntimeExports = v; },
};

var _typeofExports = {};
var _typeof = {
  get exports(){ return _typeofExports; },
  set exports(v){ _typeofExports = v; },
};

(function (module) {
	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (_typeof));

(function (module) {
	var _typeof = _typeofExports["default"];
	function _regeneratorRuntime() {
	  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
	    return exports;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  var exports = {},
	    Op = Object.prototype,
	    hasOwn = Op.hasOwnProperty,
	    defineProperty = Object.defineProperty || function (obj, key, desc) {
	      obj[key] = desc.value;
	    },
	    $Symbol = "function" == typeof Symbol ? Symbol : {},
	    iteratorSymbol = $Symbol.iterator || "@@iterator",
	    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
	    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	  function define(obj, key, value) {
	    return Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: !0,
	      configurable: !0,
	      writable: !0
	    }), obj[key];
	  }
	  try {
	    define({}, "");
	  } catch (err) {
	    define = function define(obj, key, value) {
	      return obj[key] = value;
	    };
	  }
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
	      generator = Object.create(protoGenerator.prototype),
	      context = new Context(tryLocsList || []);
	    return defineProperty(generator, "_invoke", {
	      value: makeInvokeMethod(innerFn, self, context)
	    }), generator;
	  }
	  function tryCatch(fn, obj, arg) {
	    try {
	      return {
	        type: "normal",
	        arg: fn.call(obj, arg)
	      };
	    } catch (err) {
	      return {
	        type: "throw",
	        arg: err
	      };
	    }
	  }
	  exports.wrap = wrap;
	  var ContinueSentinel = {};
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });
	  var getProto = Object.getPrototypeOf,
	    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      define(prototype, method, function (arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if ("throw" !== record.type) {
	        var result = record.arg,
	          value = result.value;
	        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
	          invoke("next", value, resolve, reject);
	        }, function (err) {
	          invoke("throw", err, resolve, reject);
	        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
	          result.value = unwrapped, resolve(result);
	        }, function (error) {
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	      reject(record.arg);
	    }
	    var previousPromise;
	    defineProperty(this, "_invoke", {
	      value: function value(method, arg) {
	        function callInvokeWithMethodAndArg() {
	          return new PromiseImpl(function (resolve, reject) {
	            invoke(method, arg, resolve, reject);
	          });
	        }
	        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	      }
	    });
	  }
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = "suspendedStart";
	    return function (method, arg) {
	      if ("executing" === state) throw new Error("Generator is already running");
	      if ("completed" === state) {
	        if ("throw" === method) throw arg;
	        return doneResult();
	      }
	      for (context.method = method, context.arg = arg;;) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
	          if ("suspendedStart" === state) throw state = "completed", context.arg;
	          context.dispatchException(context.arg);
	        } else "return" === context.method && context.abrupt("return", context.arg);
	        state = "executing";
	        var record = tryCatch(innerFn, self, context);
	        if ("normal" === record.type) {
	          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
	          return {
	            value: record.arg,
	            done: context.done
	          };
	        }
	        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
	      }
	    };
	  }
	  function maybeInvokeDelegate(delegate, context) {
	    var methodName = context.method,
	      method = delegate.iterator[methodName];
	    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
	    var record = tryCatch(method, delegate.iterator, context.arg);
	    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
	    var info = record.arg;
	    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
	  }
	  function pushTryEntry(locs) {
	    var entry = {
	      tryLoc: locs[0]
	    };
	    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
	  }
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal", delete record.arg, entry.completion = record;
	  }
	  function Context(tryLocsList) {
	    this.tryEntries = [{
	      tryLoc: "root"
	    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
	  }
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) return iteratorMethod.call(iterable);
	      if ("function" == typeof iterable.next) return iterable;
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	          next = function next() {
	            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
	            return next.value = undefined, next.done = !0, next;
	          };
	        return next.next = next;
	      }
	    }
	    return {
	      next: doneResult
	    };
	  }
	  function doneResult() {
	    return {
	      value: undefined,
	      done: !0
	    };
	  }
	  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
	    value: GeneratorFunctionPrototype,
	    configurable: !0
	  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
	    value: GeneratorFunction,
	    configurable: !0
	  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
	    var ctor = "function" == typeof genFun && genFun.constructor;
	    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
	  }, exports.mark = function (genFun) {
	    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
	  }, exports.awrap = function (arg) {
	    return {
	      __await: arg
	    };
	  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    void 0 === PromiseImpl && (PromiseImpl = Promise);
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
	    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
	    return this;
	  }), define(Gp, "toString", function () {
	    return "[object Generator]";
	  }), exports.keys = function (val) {
	    var object = Object(val),
	      keys = [];
	    for (var key in object) keys.push(key);
	    return keys.reverse(), function next() {
	      for (; keys.length;) {
	        var key = keys.pop();
	        if (key in object) return next.value = key, next.done = !1, next;
	      }
	      return next.done = !0, next;
	    };
	  }, exports.values = values, Context.prototype = {
	    constructor: Context,
	    reset: function reset(skipTempReset) {
	      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
	    },
	    stop: function stop() {
	      this.done = !0;
	      var rootRecord = this.tryEntries[0].completion;
	      if ("throw" === rootRecord.type) throw rootRecord.arg;
	      return this.rval;
	    },
	    dispatchException: function dispatchException(exception) {
	      if (this.done) throw exception;
	      var context = this;
	      function handle(loc, caught) {
	        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
	      }
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i],
	          record = entry.completion;
	        if ("root" === entry.tryLoc) return handle("end");
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc"),
	            hasFinally = hasOwn.call(entry, "finallyLoc");
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
	            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
	          } else {
	            if (!hasFinally) throw new Error("try statement without catch or finally");
	            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
	          }
	        }
	      }
	    },
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
	      var record = finallyEntry ? finallyEntry.completion : {};
	      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
	    },
	    complete: function complete(record, afterLoc) {
	      if ("throw" === record.type) throw record.arg;
	      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
	    },
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
	      }
	    },
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if ("throw" === record.type) {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	      throw new Error("illegal catch attempt");
	    },
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      return this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
	    }
	  }, exports;
	}
	module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (regeneratorRuntime$1));

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntimeExports();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var codeMessage = {
  200: 'The server successfully returned the requested data. ',
  201: 'The new or modified data was successful. ',
  202: 'A request has been queued in the background (asynchronous task). ',
  204: 'The data was deleted successfully. ',
  400: 'There was an error in the issued request. The server did not create or modify data. ',
  401: 'User does not have permission (token, username, password is wrong). ',
  403: 'The user is authorized but the access is forbidden. ',
  404: 'The request was issued for a non-existent record and the server did not perform the operation. ',
  406: 'The requested format is not available. ',
  410: 'The requested resource is permanently deleted and will not be regained. ',
  422: 'A validation error occurred while creating an object. ',
  500: 'An error occurred on the server. Please check the server. ',
  502: 'The gateway is wrong. ',
  503: 'The service is unavailable, the server is temporarily overloaded or maintained. ',
  504: 'The gateway timed out. '
};

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$2()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TimedOutError = /*#__PURE__*/function (_Error) {
  _inherits(TimedOutError, _Error);
  var _super = _createSuper$1(TimedOutError);
  function TimedOutError() {
    var _this;
    _classCallCheck(this, TimedOutError);
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    _this = _super.call.apply(_super, [this].concat(params));

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), TimedOutError);
    }
    _this.name = 'TimedOutError';
    _this.status = 504;
    _this.response = {
      status: 504,
      message: 'Request has timed out.'
    };
    // Custom debugging information
    return _this;
  }
  return _createClass(TimedOutError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ArgumentMissingError = /*#__PURE__*/function (_Error) {
  _inherits(ArgumentMissingError, _Error);
  var _super = _createSuper(ArgumentMissingError);
  function ArgumentMissingError() {
    var _this;
    var missingArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, ArgumentMissingError);
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    _this = _super.call.apply(_super, [this].concat(params));

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), ArgumentMissingError);
    }
    _this.name = 'ArgumentMissingError';
    _this.status = 422;
    _this.response = {
      status: 422,
      message: "Missing arguments: [".concat(missingArr.join(', '), "]")
    };
    // Custom debugging information
    return _this;
  }
  return _createClass(ArgumentMissingError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var _excluded$6 = ["filter", "category_ids"];
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function objectKeysToSnakeCase(obj) {
  return _.mapKeys(obj, function (v, k) {
    return _.snakeCase(k);
  });
}
function getOrderOperator(sortOrder) {
  var order = sortOrder === 'descend' ? '-' : '';
  return order;
}
function formatSortField(sortOrder, sortField) {
  if (_.isArray(sortField) && !_.isEmpty(sortField)) {
    var compactedFields = _.compact(_.map(sortField, function (field) {
      return formatSortField(sortOrder, field);
    }));
    return _.isEmpty(compactedFields) ? undefined : compactedFields;
  }
  var order = getOrderOperator(sortOrder);
  var sort = sortOrder && sortField && "".concat(order).concat(sortField);
  return sort;
}
function stringifyParams(params, arrayFormat) {
  var filter = params.filter,
    category_ids = params.category_ids,
    otherParams = _objectWithoutProperties(params, _excluded$6);
  var stringifiedCategories = stringify({
    category_ids: category_ids
  }, {
    arrayFormat: 'brackets'
  });
  var stringifiedFilters = stringify({
    filter: filter
  }, {
    arrayFormat: 'brackets'
  });
  var stringifiedOtherParams = stringify(otherParams, {
    arrayFormat: arrayFormat
  });
  var queryString = stringifiedOtherParams;
  if (!_.isEmpty(filter)) {
    queryString = queryString.concat('&', stringifiedFilters);
  }
  if (!_.isEmpty(category_ids)) {
    queryString = queryString.concat('&', stringifiedCategories);
  }
  return queryString;
}
function isEmpty(value) {
  return _.isEmpty(value);
}
function isObject() {
  return arguments.length === 1 && _.isObject(arguments.length <= 0 ? undefined : arguments[0]);
}
function getFormattedArgs() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (isObject.apply(void 0, args)) {
    var _args$ = args[0],
      _pageNumber = _args$.pageNumber,
      _args$$pageSize = _args$.pageSize,
      _pageSize = _args$$pageSize === void 0 ? 25 : _args$$pageSize,
      _sortField = _args$.sortField,
      _sortOrder = _args$.sortOrder,
      _searchQuery = _args$.searchQuery,
      _filters = _args$.filters,
      _extraQueries = _args$.extraQueries,
      _statusQuery = _args$.statusQuery,
      _args$$arrayFormat = _args$.arrayFormat,
      _arrayFormat = _args$$arrayFormat === void 0 ? 'comma' : _args$$arrayFormat;
    return {
      pageNumber: _pageNumber,
      pageSize: _pageSize,
      sortField: _sortField,
      sortOrder: _sortOrder,
      searchQuery: _searchQuery,
      filters: _filters,
      extraQueries: _extraQueries,
      statusQuery: _statusQuery,
      arrayFormat: _arrayFormat
    };
  }
  console.warn('Arguments in array format is deprecated; You should switch to object format.');
  var pageNumber = args[0],
    _args$2 = args[1],
    pageSize = _args$2 === void 0 ? 25 : _args$2,
    sortField = args[2],
    sortOrder = args[3],
    searchQuery = args[4],
    filters = args[5],
    extraQueries = args[6],
    statusQuery = args[7],
    _args$3 = args[8],
    arrayFormat = _args$3 === void 0 ? 'comma' : _args$3;
  return {
    pageNumber: pageNumber,
    pageSize: pageSize,
    sortField: sortField,
    sortOrder: sortOrder,
    searchQuery: searchQuery,
    filters: filters,
    extraQueries: extraQueries,
    statusQuery: statusQuery,
    arrayFormat: arrayFormat
  };
}
function formatQueryString(args) {
  var pageNumber = args.pageNumber,
    pageSize = args.pageSize,
    sortField = args.sortField,
    sortOrder = args.sortOrder,
    searchQuery = args.searchQuery,
    filters = args.filters,
    extraQueries = args.extraQueries,
    arrayFormat = args.arrayFormat;
  var sort = formatSortField(sortOrder, sortField);
  var obj = _objectSpread$5(_objectSpread$5({
    page: {
      number: pageNumber,
      size: pageSize
    },
    sort: sort,
    search: searchQuery && searchQuery.length > 0 ? searchQuery : null
  }, objectKeysToSnakeCase(filters)), objectKeysToSnakeCase(extraQueries));
  var compactedObj = _.pickBy(obj, function (val) {
    return !_.isEmpty(val) || _.isBoolean(val);
  });
  return stringifyParams(compactedObj, arrayFormat);
}

// eslint-disable-next-line no-promise-executor-return
var timeout = function timeout(duration) {
  return new Promise(function (res, rej) {
    return setTimeout(function () {
      return rej(new TimedOutError(codeMessage[504]));
    }, duration);
  });
};
var checkStatus = function checkStatus(notifyError) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(response) {
      var jsonResponse, errortext, error;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(response.status >= 200 && response.status < 300)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", response);
          case 2:
            _context.next = 4;
            return response.json();
          case 4:
            jsonResponse = _context.sent;
            errortext = codeMessage[response.status] || response.statusText;
            if (response.status !== 422) {
              notifyError({
                message: "Request error ".concat(response.status, ": ").concat(response.url),
                description: errortext,
                status: response.status
              });
            }
            error = new Error(errortext);
            error.status = response.status;
            error.response = jsonResponse;
            throw error;
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var compact = function compact(obj) {
  if (_.isArray(obj)) {
    return _.compact(obj);
  }
  if (_typeof$1(obj) === 'object') {
    return _.pickBy(obj);
  }
  return obj;
};

function omit(array) {
  return array.filter(function (value) {
    return !!value;
  });
}
function getRequestPath(name) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return omit([prefix, name]).join('/');
}
function createService(resource) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prefix = opts.prefix,
    _opts$except = opts.except,
    except = _opts$except === void 0 ? [] : _opts$except,
    _opts$type = opts.type,
    type = _opts$type === void 0 ? resource : _opts$type,
    _opts$extend = opts.extend,
    extend = _opts$extend === void 0 ? {} : _opts$extend;
  var path = getRequestPath(resource, prefix);
  var methods = {
    create: function create(params) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(type, "/api/".concat(path), {
                method: 'POST',
                body: params
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    read: function read(id) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", _this2.request(type, "/api/".concat(path, "/").concat(id)));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    update: function update(id, params) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", _this3.request(type, "/api/".concat(path, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    "delete": function _delete(id) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", _this4.request(type, "/api/".concat(path, "/").concat(id), {
                method: 'DELETE'
              }));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    search: function search() {
      var _arguments = arguments,
        _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
        var queryParams, queryString, statusQuery;
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
              queryString = formatQueryString(queryParams);
              statusQuery = queryParams.statusQuery;
              if (statusQuery) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return", _this5.request(type, "/api/".concat(path, "?").concat(queryString)));
            case 5:
              return _context5.abrupt("return", _this5.request(type, "/api/".concat(path, "?").concat(queryString, "&").concat(statusQuery)));
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  };
  except.forEach(function (methodName) {
    delete methods[methodName];
  });
  return Object.assign(methods, extend);
}

var resource$R = 'patients';
var PatientsApi = createService(resource$R);

var resource$Q = 'external_patients';
var ExternalPatientsApi = {
  read: function read(system, id) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$Q, "/api/patients/external/".concat(system, "/").concat(id)));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};

var parentResource$b = 'patients';
var carePlans = 'care_plans';
var ActivityMoveApi = {
  read: function read(id) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(parentResource$b, "/api/".concat(parentResource$b, "/").concat(id, "/").concat(carePlans)));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  update: function update(params) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      var id;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            id = params.id;
            return _context2.abrupt("return", _this2.request(parentResource$b, "/api/".concat(parentResource$b, "/care_plan_activities/").concat(id, "/move"), {
              method: 'PUT',
              body: params
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};

var resource$P = 'care_plans';
var CarePlansApi = createService(resource$P, {
  extend: {
    send: function send(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$P, "/api/".concat(resource$P, "/").concat(id, "/send"), {
                method: 'POST'
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * @param {string} carePlanId
     * @param {Array<string>} exercises CarePlanActivity IDs, in the order they should be set to.
     * @returns {Promise<any>}
     */
    reorder: function reorder(carePlanId, exercises) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", _this2.request(resource$P, "/api/".concat(resource$P, "/").concat(carePlanId, "/reorder"), {
                method: 'PATCH',
                body: {
                  exercises: exercises
                }
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
});

var _excluded$5 = ["parentId"];
var resource$O = 'care_plan_activities';
var parentResource$a = 'care_plans';
var CarePlanActivitiesApi = {
  create: function create(parentId, params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$O, "/api/".concat(parentResource$a, "/").concat(parentId, "/").concat(resource$O), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read(parentId, id) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$O, "/api/".concat(parentResource$a, "/").concat(parentId, "/").concat(resource$O, "/").concat(id)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  getEvents: function getEvents(id, args) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = getFormattedArgs(args);
            queryString = formatQueryString(queryParams);
            return _context3.abrupt("return", _this3.request(resource$O, "/api/".concat(resource$O, "/").concat(id, "/events?").concat(queryString)));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  send: function send(id) {
    return this.request(resource$O, "/api/".concat(resource$O, "/").concat(id, "/send"), {
      method: 'POST'
    });
  },
  getPlannableEvents: function getPlannableEvents(parentId, plannableId, args) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            queryParams = getFormattedArgs(args);
            queryString = formatQueryString(queryParams);
            return _context4.abrupt("return", _this4.request(resource$O, "/api/".concat(parentResource$a, "/").concat(parentId, "/").concat(resource$O, "/").concat(plannableId, "/events?").concat(queryString)));
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  update: function update(parentId, id, params) {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _this5.request(resource$O, "/api/".concat(parentResource$a, "/").concat(parentId, "/").concat(resource$O, "/").concat(id), {
              method: 'PATCH',
              body: params
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  "delete": function _delete(parentId, id) {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", _this6.request(resource$O, "/api/".concat(parentResource$a, "/").concat(parentId, "/").concat(resource$O, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  search: function search() {
    var _arguments = arguments,
      _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7() {
      var parentId, rest, queryParams, _len, args, _key, _args$, queryString;
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            for (_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _arguments[_key];
            }
            if (!isEmpty(args)) {
              _context7.next = 3;
              break;
            }
            throw new ArgumentMissingError(['parentId']);
          case 3:
            if (isObject.apply(void 0, args)) {
              // eslint-disable-next-line prefer-destructuring
              _args$ = args[0];
              parentId = _args$.parentId;
              rest = _objectWithoutProperties(_args$, _excluded$5);
              queryParams = getFormattedArgs(rest);
            } else {
              console.warn('Arguments in array format is deprecated; You should switch to object format.', 'CarePlanActivities');
              parentId = args[0];
              rest = args.slice(1);
              queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(rest));
            }
            queryString = formatQueryString(queryParams);
            return _context7.abrupt("return", _this7.request(resource$O, "/api/".concat(parentResource$a, "/").concat(parentId, "/").concat(resource$O, "?").concat(queryString)));
          case 6:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  }
};

var resource$N = 'email_templates';
var EmailTemplatesApi = createService(resource$N, {
  extend: {
    variables: function variables() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$N, "/api/".concat(resource$N, "/variables")));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    preview: function preview(id) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", _this2.request(resource$N, "/api/".concat(resource$N, "/").concat(id, "/preview")));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
});

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var resource$M = 'auth';
var AuthApi = {
  readInvitation: function readInvitation(token) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.requestPublic(resource$M, "/api/auth/invitations?invitation_token=".concat(token)));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  acceptInvitation: function acceptInvitation(token, params) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.requestPublic(resource$M, '/api/auth/invitations', {
              method: 'PUT',
              body: {
                accept_invitation: _objectSpread$4(_objectSpread$4({}, params), {}, {
                  invitation_token: token
                })
              }
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  sendInvite: function sendInvite(params) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(resource$M, '/api/auth/send_invite', {
              method: 'POST',
              body: {
                invite: params
              }
            }, false));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  sendUsername: function sendUsername(params) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this4.requestPublic(resource$M, '/api/auth/usernames', {
              method: 'POST',
              body: {
                user: _objectSpread$4({}, params)
              }
            }, false));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  changePassword: function changePassword(_ref) {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var newPassword, newPasswordConfirmation, currentPassword;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            newPassword = _ref.newPassword, newPasswordConfirmation = _ref.newPasswordConfirmation, currentPassword = _ref.currentPassword;
            return _context5.abrupt("return", _this5.request(resource$M, '/api/auth/passwords', {
              method: 'PUT',
              body: {
                password: newPassword,
                password_confirmation: newPasswordConfirmation,
                current_password: currentPassword
              }
            }, false));
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  sendPassword: function sendPassword(params) {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", _this6.requestPublic(resource$M, '/api/auth/passwords', {
              method: 'POST',
              body: {
                username: params.username,
                redirect_uri: _this6.reactAppSiteUrl
              }
            }, false));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  validateRegistrationCode: function validateRegistrationCode(params) {
    var _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7() {
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", _this7.requestPublic(resource$M, '/api/registration_codes/validate', {
              method: 'POST',
              body: params
            }, false));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  registerPatient: function registerPatient(params) {
    var _this8 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8() {
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", _this8.requestPublic(resource$M, '/api/auth/patients', {
              method: 'POST',
              body: params
            }, false));
          case 1:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  }
};

var resource$L = 'templates';
var TemplatesApi = createService(resource$L, {
  type: 'care_plans',
  extend: {
    applyTemplate: function applyTemplate(params) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request('care_plans', '/api/apply_templates', {
                method: 'POST',
                body: params
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var _excluded$4 = ["parentId"];
var resource$K = 'template_activities';
var parentResource$9 = 'templates';
var TemplateActivitiesApi = {
  create: function create(parentId, params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$K, "/api/".concat(parentResource$9, "/").concat(parentId, "/").concat(resource$K), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read(parentId, id) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$K, "/api/".concat(parentResource$9, "/").concat(parentId, "/").concat(resource$K, "/").concat(id)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  update: function update(parentId, id, params) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(resource$K, "/api/".concat(parentResource$9, "/").concat(parentId, "/").concat(resource$K, "/").concat(id), {
              method: 'PATCH',
              body: params
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  "delete": function _delete(parentId, id) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this4.request(resource$K, "/api/".concat(parentResource$9, "/").concat(parentId, "/").concat(resource$K, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  search: function search() {
    var _arguments = arguments,
      _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var parentId, rest, queryParams, _len, args, _key, _args$, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            for (_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _arguments[_key];
            }
            if (!isEmpty(args)) {
              _context5.next = 3;
              break;
            }
            throw new ArgumentMissingError(['parentId']);
          case 3:
            if (isObject.apply(void 0, args)) {
              // eslint-disable-next-line prefer-destructuring
              _args$ = args[0];
              parentId = _args$.parentId;
              rest = _objectWithoutProperties(_args$, _excluded$4);
              queryParams = getFormattedArgs(rest);
            } else {
              console.warn('Arguments in array format is deprecated; You should switch to object format.', 'TemplateActivities');
              parentId = args[0];
              rest = args.slice(1);
              queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(rest));
            }
            queryString = formatQueryString(queryParams);
            return _context5.abrupt("return", _this5.request(resource$K, "/api/".concat(parentResource$9, "/").concat(parentId, "/").concat(resource$K, "?").concat(queryString)));
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};

var resource$J = 'workflows';
var WorkflowsApi = createService(resource$J, {
  extend: {
    options: function options() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$J, "/api/".concat(resource$J, "/options/")));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var resource$I = 'actions';
var WorkflowActionsApi = {
  create: function create(params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$I, "/api/workflows/".concat(resource$I), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read(id) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$I, "/api/workflows/".concat(resource$I, "/").concat(id)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  update: function update(id, params) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(resource$I, "/api/workflows/".concat(resource$I, "/").concat(id), {
              method: 'PATCH',
              body: _objectSpread$3({}, params)
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  "delete": function _delete(id) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this4.request(resource$I, "/api/workflows/".concat(resource$I, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  search: function search() {
    var _arguments = arguments,
      _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
            queryString = formatQueryString(queryParams);
            return _context5.abrupt("return", _this5.request(resource$I, "/api/workflows/".concat(resource$I, "?").concat(queryString)));
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};

var resource$H = 'triggered_actions';
var WorkflowTriggersApi = {
  create: function create(params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$H, "/api/workflows/".concat(resource$H), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read(id) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$H, "/api/workflows/".concat(resource$H, "/").concat(id)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  update: function update(id, params) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(resource$H, "/api/workflows/".concat(resource$H, "/").concat(id), {
              method: 'PATCH',
              body: params
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  "delete": function _delete(id) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this4.request(resource$H, "/api/workflows/".concat(resource$H, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  search: function search() {
    var _arguments = arguments,
      _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
            queryString = formatQueryString(queryParams);
            return _context5.abrupt("return", _this5.request(resource$H, "/api/workflows/".concat(resource$H, "?").concat(queryString)));
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};

var resource$G = 'practitioners';
var PractitionersApi = createService(resource$G);

var resource$F = 'profile';
var ProfileApi = {
  read: function read() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$F, "/api/".concat(resource$F)));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  update: function update(params) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$F, "/api/".concat(resource$F), {
              method: 'PATCH',
              body: params
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  selectOrganization: function selectOrganization(id) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(resource$F, "/api/current_organization/".concat(id)));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
};

var resource$E = 'questionnaires';
var QuestionnairesApi = createService(resource$E, {
  extend: {
    update_version: function update_version(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$E, "/api/".concat(resource$E, "/").concat(id, "/update_version"), {
                method: 'POST'
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var _excluded$3 = ["parentId"];
function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var resource$D = 'questionnaire_responses';
var parentResource$8 = 'care_plan_activities';
var QuestionnaireResponsesApi = {
  create: function create(parentId, params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$D, "/api/".concat(resource$D), {
              method: 'POST',
              body: _objectSpread$2(_objectSpread$2({}, params), {}, {
                care_plan_activity_id: parentId
              })
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read(parentId, id) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$D, "/api/".concat(parentResource$8, "/").concat(parentId, "/").concat(resource$D, "/").concat(id)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  update: function update(parentId, id, params) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(resource$D, "/api/".concat(resource$D, "/").concat(id), {
              method: 'PATCH',
              body: _objectSpread$2(_objectSpread$2({}, params), {}, {
                care_plan_activity_id: parentId
              })
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  "delete": function _delete(parentId, id) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this4.request(resource$D, "/api/".concat(parentResource$8, "/").concat(parentId, "/").concat(resource$D, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  search: function search() {
    var _arguments = arguments,
      _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var parentId, rest, queryParams, _len, args, _key, _args$, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            for (_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _arguments[_key];
            }
            if (isObject.apply(void 0, args)) {
              // eslint-disable-next-line prefer-destructuring
              _args$ = args[0];
              parentId = _args$.parentId;
              rest = _objectWithoutProperties(_args$, _excluded$3);
              queryParams = getFormattedArgs(rest);
            } else {
              console.warn('Arguments in array format is deprecated; You should switch to object format.', 'QuestionnaireResponses');
              parentId = args[0];
              rest = args.slice(1);
              queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(rest));
            }
            queryString = formatQueryString(_objectSpread$2(_objectSpread$2({}, queryParams), {}, {
              filters: _objectSpread$2(_objectSpread$2({}, queryParams.filters || {}), {}, {
                care_plan_activity_id: parentId
              })
            }));
            return _context5.abrupt("return", _this5.request(resource$D, "/api/".concat(resource$D, "?").concat(queryString)));
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  rescore: function rescore(id, params) {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", _this6.request(resource$D, "/api/".concat(resource$D, "/").concat(id, "/questionnaire_scores"), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }
};

var resource$C = 'questionnaire_items';
var parentResource$7 = 'questionnaires';
var QuestionnaireItemsApi = {
  create: function create(parentId, params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$C, "/api/".concat(parentResource$7, "/").concat(parentId, "/").concat(resource$C), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  update: function update(parentId, id, params) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$C, "/api/".concat(parentResource$7, "/").concat(parentId, "/").concat(resource$C, "/").concat(id), {
              method: 'PATCH',
              body: params
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  "delete": function _delete(parentId, id) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(resource$C, "/api/".concat(parentResource$7, "/").concat(parentId, "/").concat(resource$C, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
};

var resource$B = 'contents';
var ContentsApi = createService(resource$B);

var resource$A = 'appointments';
var AppointmentsApi = createService(resource$A);

var resource$z = 'encounters';
var EncountersApi = createService(resource$z);

var resource$y = 'communications';
var CommunicationsApi = createService(resource$y);

var resource$x = 'locations';
var LocationsApi = createService(resource$x);

var resource$w = 'media';
var MediaApi = createService(resource$w);

var resource$v = 'media_assets';
var MediaAssetsApi = createService(resource$v);

var resource$u = 'organizations';
var OrganizationsApi = createService(resource$u);

var resource$t = 'users';
var UsersApi = createService(resource$t, {
  extend: {
    password: function password(id, params) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$t, "/api/".concat(resource$t, "/").concat(id, "/password"), {
                method: 'PUT',
                body: params
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var resource$s = 'tags';
var ResourceTagsApi = {
  create: function create(id, resourceType, params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$s, "/api/".concat(resourceType, "/").concat(id, "/").concat(resource$s), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  "delete": function _delete(id, resourceType, params) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$s, "/api/".concat(resourceType, "/").concat(id, "/").concat(resource$s), {
              method: 'DELETE',
              body: params
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  search: function search() {
    var _arguments = arguments,
      _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
            queryString = formatQueryString(queryParams);
            return _context3.abrupt("return", _this3.request(resource$s, "/api/".concat(resource$s, "?").concat(queryString)));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
};

var resource$r = 'parent_organizations';
var ParentOrganizationsApi = createService(resource$r);

var parentResource$6 = 'library';
var searchResource = 'search';
var carePlanActivities = 'care_plan_activities';
var SearchApi = {
  search: function search() {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
            queryString = formatQueryString(queryParams);
            return _context.abrupt("return", _this.request(parentResource$6, "/api/".concat(parentResource$6, "/").concat(searchResource, "?").concat(queryString)));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  create: function create(params) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(parentResource$6, "/api/".concat(parentResource$6, "/").concat(carePlanActivities), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};

var resource$q = 'episodes_of_care';
var EpisodesOfCareApi = createService(resource$q);

var resource$p = 'observations';
var ObservationsApi = createService(resource$p);

var AccountsApi = createService('accounts');

var resource$o = 'measure_reports';
var MeasureReportsApi = createService(resource$o, {
  except: ['delete']
});

var resource$n = 'conversations';
var ConversationsApi = createService(resource$n);

var _excluded$2 = ["conversationId"];
var resource$m = 'messages';
var MessagesApi = {
  create: function create(conversationId, params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$m, "/api/conversations/".concat(conversationId, "/").concat(resource$m), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read(conversationId, id) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$m, "/api/conversations/".concat(conversationId, "/").concat(resource$m, "/").concat(id)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  update: function update(conversationId, id, params) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(resource$m, "/api/conversations/".concat(conversationId, "/").concat(resource$m, "/").concat(id), {
              method: 'PATCH',
              body: params
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  "delete": function _delete(conversationId, id) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this4.request(resource$m, "/api/conversations/".concat(conversationId, "/").concat(resource$m, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  searchLatest: function searchLatest() {
    var _arguments = arguments,
      _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
            queryString = formatQueryString(queryParams);
            return _context5.abrupt("return", _this5.request(resource$m, "/api/".concat(resource$m, "?").concat(queryString)));
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  search: function search() {
    var _arguments2 = arguments,
      _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      var conversationId, rest, queryParams, _len, args, _key, _args$, queryString;
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            for (_len = _arguments2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _arguments2[_key];
            }
            if (args.length === 1) {
              // eslint-disable-next-line prefer-destructuring
              _args$ = args[0];
              conversationId = _args$.conversationId;
              rest = _objectWithoutProperties(_args$, _excluded$2);
              queryParams = getFormattedArgs(rest);
            } else {
              conversationId = args[0];
              rest = args.slice(1);
              queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(rest));
            }
            queryString = formatQueryString(queryParams);
            return _context6.abrupt("return", _this6.request(resource$m, "/api/conversations/".concat(conversationId, "/").concat(resource$m, "?").concat(queryString)));
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }
};

var resource$l = 'categories';
var CategoriesApi = {
  search: function search() {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
            queryString = formatQueryString(queryParams);
            return _context.abrupt("return", _this.request(resource$l, "/api/".concat(resource$l, "?").concat(queryString)));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};

var resource$k = 'qr_codes';
var QRCodesApi = {
  read: function read(id) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$k, "/api/".concat(resource$k, "?care_plan_activity_id=").concat(id)));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};

var resource$j = 'nps_trackers';
var NpsTrackersApi = {
  search: function search() {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
            queryString = formatQueryString(queryParams);
            return _context.abrupt("return", _this.request(resource$j, "/api/".concat(resource$j, "?").concat(queryString)));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};

var resource$i = 'diagnosis_classifications';
var DiagnosisClassificationsApi = createService(resource$i, {
  except: ['read', 'update', 'delete', 'create']
});

var resource$h = 'conditions';
var ConditionsApi = createService(resource$h, {
  except: ['search', 'read']
});

var resource$g = 'diagnoses';
var DiagnosesApi = createService(resource$g, {
  except: ['search', 'read']
});

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var parentResource$5 = 'submission_practitioners';
var MipsSubmissionPractitionerApi = {
  getSubmissions: function getSubmissions() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(parentResource$5, "/api/".concat(parentResource$5)));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read(_ref) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      var args, submission_id;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            args = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
            submission_id = args.submission_id;
            return _context2.abrupt("return", _this2.request(parentResource$5, "/api/".concat(parentResource$5, "/").concat(submission_id)));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  search: function search(params) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var practitioner_id;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            practitioner_id = params.practitioner_id;
            return _context3.abrupt("return", _this3.request(parentResource$5, "/api/".concat(parentResource$5, "?practitioner_id=").concat(practitioner_id)));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  create: function create(params) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this4.request(parentResource$5, "/api/".concat(parentResource$5), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  update: function update(params) {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var id;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            id = params.id;
            return _context5.abrupt("return", _this5.request(parentResource$5, "/api/".concat(parentResource$5, "/").concat(id), {
              method: 'PUT',
              body: params
            }));
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};

var parentResource$4 = 'submissions';
var MipsSubmissionsApi = {
  search: function search() {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
            queryString = formatQueryString(queryParams);
            return _context.abrupt("return", _this.request(parentResource$4, "/api/".concat(parentResource$4, "/?").concat(queryString)));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(parentResource$4, "/api/".concat(parentResource$4), {
              method: 'GET'
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  getDetail: function getDetail(id) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(parentResource$4, "/api/".concat(parentResource$4, "/").concat(id), {
              method: 'GET'
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  update: function update(params) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      var id;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            id = params.id;
            return _context4.abrupt("return", _this4.request(parentResource$4, "/api/".concat(parentResource$4, "/").concat(id), {
              method: 'PUT',
              body: params
            }));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  create: function create(params) {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _this5.request(parentResource$4, "/api/".concat(parentResource$4), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  submit: function submit(params) {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      var id;
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            id = params.id;
            return _context6.abrupt("return", _this6.request(parentResource$4, "/api/".concat(parentResource$4, "/").concat(id, "/submit"), {
              method: 'POST',
              body: params
            }));
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  "delete": function _delete(id) {
    var _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7() {
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", _this7.request(parentResource$4, "/api/".concat(parentResource$4, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  }
};

var parentResource$3 = 'submission_responses';
var MipsSubmissionResponsesApi = {
  search: function search() {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(_arguments));
            queryString = formatQueryString(queryParams);
            return _context.abrupt("return", _this.request(parentResource$3, "/api/".concat(parentResource$3, "/?").concat(queryString)));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(parentResource$3, "/api/".concat(parentResource$3), {
              method: 'GET'
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  getDetail: function getDetail(id) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(parentResource$3, "/api/".concat(parentResource$3, "?submission_id=").concat(id), {
              method: 'GET'
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  update: function update(params) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      var id;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            id = params.id;
            return _context4.abrupt("return", _this4.request(parentResource$3, "/api/".concat(parentResource$3, "/").concat(id), {
              method: 'PUT',
              body: params
            }));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  create: function create(params) {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _this5.request(parentResource$3, "/api/".concat(parentResource$3), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  "delete": function _delete(id) {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", _this6.request(parentResource$3, "/api/".concat(parentResource$3, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }
};

var resource$f = 'fhir';
var parentResource$2 = 'questionnaires';
var FhirApi = {
  read: function read(parentId, id) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$f, "/api/fhir/".concat(parentResource$2, "/").concat(parentId, "/_history/").concat(id)));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};

var resource$e = 'brands';
var BrandsApi = createService(resource$e);

var resource$d = 'care_plans';
var AdminCarePlansApi = createService(resource$d, {
  prefix: 'admin',
  extend: {
    send: function send(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$d, "/api/admin/".concat(resource$d, "/").concat(id, "/send"), {
                method: 'POST'
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var _excluded$1 = ["parentId"];
var resource$c = 'care_plan_activities';
var parentResource$1 = 'care_plans';
var AdminCarePlanActivitiesApi = {
  create: function create(parentId, params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$c, "/api/admin/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$c), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read(parentId, id) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$c, "/api/admin/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$c, "/").concat(id)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  getEvents: function getEvents(id, args) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var queryParams, queryString;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = getFormattedArgs(args);
            queryString = formatQueryString(queryParams);
            return _context3.abrupt("return", _this3.request(resource$c, "/api/admin/".concat(resource$c, "/").concat(id, "/events?").concat(queryString)));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  update: function update(parentId, id, params) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this4.request(resource$c, "/api/admin/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$c, "/").concat(id), {
              method: 'PATCH',
              body: params
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  "delete": function _delete(parentId, id) {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _this5.request(resource$c, "/api/admin/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$c, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  search: function search() {
    var _arguments = arguments,
      _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      var parentId, rest, queryParams, _len, args, _key, _args$, queryString;
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            for (_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _arguments[_key];
            }
            if (!isEmpty(args)) {
              _context6.next = 3;
              break;
            }
            throw new ArgumentMissingError(['parentId']);
          case 3:
            if (isObject.apply(void 0, args)) {
              // eslint-disable-next-line prefer-destructuring
              _args$ = args[0];
              parentId = _args$.parentId;
              rest = _objectWithoutProperties(_args$, _excluded$1);
              queryParams = getFormattedArgs(rest);
            } else {
              console.warn('Arguments in array format is deprecated; You should switch to object format.', 'CarePlanActivities');
              parentId = args[0];
              rest = args.slice(1);
              queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(rest));
            }
            queryString = formatQueryString(queryParams);
            return _context6.abrupt("return", _this6.request(resource$c, "/api/admin/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$c, "?").concat(queryString)));
          case 6:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }
};

var resource$b = 'conditions';
var AdminConditionsApi = createService(resource$b, {
  prefix: 'admin',
  except: ['search', 'read']
});

var resource$a = 'diagnoses';
var AdminDiagnosesApi = createService(resource$a, {
  prefix: 'admin',
  except: ['search', 'read']
});

var AdminBrandsApi = createService('brands', {
  prefix: 'admin'
});

var AdminContentsApi = createService('contents', {
  prefix: 'admin'
});

var AdminEmailTemplatesApi = createService('email_templates', {
  prefix: 'admin',
  extend: {
    variables: function variables() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request('email_templates', "/api/email_templates/variables"));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var AdminEncountersApi = createService('encounters', {
  prefix: 'admin'
});

var AdminLocationsApi = createService('locations', {
  prefix: 'admin'
});

var AdminOrganizationsApi = createService('organizations', {
  prefix: 'admin'
});

var resource$9 = 'patients';
var AdminPatientsApi = createService(resource$9, {
  prefix: 'admin',
  extend: {
    undelete: function undelete(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$9, "/api/admin/".concat(resource$9, "/").concat(id, "/undelete"), {
                method: 'PUT'
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var resource$8 = 'practitioners';
var AdminPractitionersApi = createService(resource$8, {
  prefix: 'admin',
  extend: {
    undelete: function undelete(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$8, "/api/admin/".concat(resource$8, "/").concat(id, "/undelete"), {
                method: 'PUT'
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var resource$7 = 'questionnaires';
var AdminQuestionnairesApi = createService(resource$7, {
  prefix: 'admin'
});

var _excluded = ["parentId"];
function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var resource$6 = 'questionnaire_responses';
var parentResource = 'care_plan_activities';
var AdminQuestionnaireResponsesApi = {
  create: function create(parentId, params) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.request(resource$6, "/api/admin/".concat(resource$6), {
              method: 'POST',
              body: _objectSpread$1(_objectSpread$1({}, params), {}, {
                care_plan_activity_id: parentId
              })
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  read: function read(parentId, id) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this2.request(resource$6, "/api/admin/".concat(parentResource, "/").concat(parentId, "/").concat(resource$6, "/").concat(id)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  update: function update(parentId, id, params) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _this3.request(resource$6, "/api/admin/".concat(resource$6, "/").concat(id), {
              method: 'PATCH',
              body: _objectSpread$1(_objectSpread$1({}, params), {}, {
                care_plan_activity_id: parentId
              })
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  "delete": function _delete(parentId, id) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _this4.request(resource$6, "/api/admin/".concat(parentResource, "/").concat(parentId, "/").concat(resource$6, "/").concat(id), {
              method: 'DELETE'
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  search: function search() {
    var _arguments = arguments,
      _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var parentId, rest, queryParams, _len, args, _key, _args$, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            for (_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _arguments[_key];
            }
            if (isObject.apply(void 0, args)) {
              // eslint-disable-next-line prefer-destructuring
              _args$ = args[0];
              parentId = _args$.parentId;
              rest = _objectWithoutProperties(_args$, _excluded);
              queryParams = getFormattedArgs(rest);
            } else {
              console.warn('Arguments in array format is deprecated; You should switch to object format.', 'AdminQuestionnaireResponses');
              parentId = args[0];
              rest = args.slice(1);
              queryParams = getFormattedArgs.apply(void 0, _toConsumableArray(rest));
            }
            queryString = formatQueryString(_objectSpread$1(_objectSpread$1({}, queryParams), {}, {
              filters: _objectSpread$1(_objectSpread$1({}, queryParams.filters || {}), {}, {
                care_plan_activity_id: parentId
              })
            }));
            return _context5.abrupt("return", _this5.request(resource$6, "/api/admin/".concat(resource$6, "?").concat(queryString)));
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  rescore: function rescore(id, params) {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", _this6.request(resource$6, "/api/admin/".concat(resource$6, "/").concat(id, "/questionnaire_scores"), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }
};

var resource$5 = 'templates';
var AdminTemplatesApi = createService(resource$5, {
  prefix: 'admin',
  type: 'care_plans',
  extend: {
    applyTemplate: function applyTemplate(params) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request('care_plans', '/api/admin/apply_templates', {
                method: 'POST',
                body: params
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var resource$4 = 'users';
var AdminUsersApi = createService(resource$4, {
  prefix: 'admin',
  extend: {
    undelete: function undelete(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$4, "/api/".concat(resource$4, "/").concat(id, "/undelete"), {
                method: 'PUT'
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var resource$3 = 'workflows';
var AdminWorkflowsApi = createService(resource$3, {
  prefix: 'admin',
  extend: {
    options: function options() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.request(resource$3, "/api/admin/".concat(resource$3, "/options/")));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

var AdminIntegrationsApi = createService('integrations', {
  prefix: 'admin',
  except: ['delete']
});

var resource$2 = 'registration_codes';
var AdminRegistrationCodesApi = createService(resource$2, {
  prefix: 'admin',
  except: ['delete']
});

var resource$1 = 'client_applications';
var AdminClientApplicationsApi = createService(resource$1, {
  prefix: 'admin',
  except: ['delete']
});

var AdminEpisodesOfCareApi = createService('episodes_of_care', {
  prefix: 'admin'
});

var resource = 'registration_codes';
var RegistrationCodesApi = createService(resource, {
  except: ['delete']
});

var services = /*#__PURE__*/Object.freeze({
  __proto__: null,
  accounts: AccountsApi,
  actions: WorkflowActionsApi,
  activity_move: ActivityMoveApi,
  admin_brands: AdminBrandsApi,
  admin_care_plan_activities: AdminCarePlanActivitiesApi,
  admin_care_plans: AdminCarePlansApi,
  admin_client_applications: AdminClientApplicationsApi,
  admin_conditions: AdminConditionsApi,
  admin_contents: AdminContentsApi,
  admin_diagnoses: AdminDiagnosesApi,
  admin_email_templates: AdminEmailTemplatesApi,
  admin_encounters: AdminEncountersApi,
  admin_episodes_of_care: AdminEpisodesOfCareApi,
  admin_integrations: AdminIntegrationsApi,
  admin_locations: AdminLocationsApi,
  admin_organizations: AdminOrganizationsApi,
  admin_patients: AdminPatientsApi,
  admin_practitioners: AdminPractitionersApi,
  admin_questionnaire_responses: AdminQuestionnaireResponsesApi,
  admin_questionnaires: AdminQuestionnairesApi,
  admin_registration_codes: AdminRegistrationCodesApi,
  admin_templates: AdminTemplatesApi,
  admin_users: AdminUsersApi,
  admin_workflows: AdminWorkflowsApi,
  appointments: AppointmentsApi,
  auth: AuthApi,
  brands: BrandsApi,
  care_plan_activities: CarePlanActivitiesApi,
  care_plans: CarePlansApi,
  categories: CategoriesApi,
  client_applications: AdminClientApplicationsApi,
  communications: CommunicationsApi,
  conditions: ConditionsApi,
  contents: ContentsApi,
  conversations: ConversationsApi,
  diagnoses: DiagnosesApi,
  diagnosis_classifications: DiagnosisClassificationsApi,
  email_templates: EmailTemplatesApi,
  encounters: EncountersApi,
  episodes_of_care: EpisodesOfCareApi,
  external_patients: ExternalPatientsApi,
  fhir: FhirApi,
  locations: LocationsApi,
  measure_reports: MeasureReportsApi,
  media: MediaApi,
  media_assets: MediaAssetsApi,
  messages: MessagesApi,
  nps_trackers: NpsTrackersApi,
  observations: ObservationsApi,
  organizations: OrganizationsApi,
  parent_organizations: ParentOrganizationsApi,
  patients: PatientsApi,
  practitioners: PractitionersApi,
  profile: ProfileApi,
  qr_codes: QRCodesApi,
  questionnaire_items: QuestionnaireItemsApi,
  questionnaire_responses: QuestionnaireResponsesApi,
  questionnaires: QuestionnairesApi,
  registration_codes: RegistrationCodesApi,
  resource_tags: ResourceTagsApi,
  search: SearchApi,
  submission_practitioners: MipsSubmissionPractitionerApi,
  submission_responses: MipsSubmissionResponsesApi,
  submissions: MipsSubmissionsApi,
  template_activities: TemplateActivitiesApi,
  templates: TemplatesApi,
  triggered_actions: WorkflowTriggersApi,
  users: UsersApi,
  workflows: WorkflowsApi
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TIMEOUT_DURATION = 15 * 1000;

// TODO: API Version Headers should be kept somewhere else
var baseHeaders = {
  Accept: 'application/json, application/vdn.keethealth.com; version=2'
};
var postHeaders = {
  'Content-Type': 'application/json; charset=utf-8'
};
var fields = ['apiUrl', 'reactAppSiteUrl', 'TTL', 'API_TIMEOUT', 'onUnauthorized', 'getCurrentSession', 'notifyError', 'onError'];
var defaultConfig = {
  API_TIMEOUT: TIMEOUT_DURATION
};
var Client = /*#__PURE__*/_createClass(function Client() {
  var _this = this;
  var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck(this, Client);
  _defineProperty(this, "getAccessToken", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var session, _session, accessToken;
    return regenerator.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return _this.getCurrentSession();
        case 3:
          session = _context.sent;
          _session = session, accessToken = _session.accessToken;
          return _context.abrupt("return", accessToken);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", null);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  })));
  _defineProperty(this, "getHeaders", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var token, defaultHeaders;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return _this.getAccessToken();
        case 2:
          token = _context2.sent;
          if (!token) {
            _this.onUnauthorized();
          }
          defaultHeaders = {
            Authorization: "Bearer ".concat(token)
          };
          if (_this.headers) {
            defaultHeaders = _this.headers(defaultHeaders);
          }
          return _context2.abrupt("return", defaultHeaders);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  _defineProperty(this, "request", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(resourceType, path) {
      var options,
        isData,
        headers,
        requestParams,
        _args3 = arguments;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
            isData = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : true;
            _context3.next = 4;
            return _this.getHeaders();
          case 4:
            headers = _context3.sent;
            // eslint-disable-next-line no-use-before-define
            requestParams = getRequestBody({
              request: _objectSpread({}, options),
              headers: headers,
              options: {
                isData: isData,
                type: resourceType
              }
            });
            return _context3.abrupt("return", _this._request(path, requestParams));
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }());
  _defineProperty(this, "requestPublic", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(resourceType, path) {
      var options,
        requestParams,
        _args4 = arguments;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            // eslint-disable-next-line no-use-before-define
            requestParams = getRequestBody({
              request: _objectSpread({}, options),
              headers: {},
              options: {
                isData: false,
                type: resourceType
              }
            });
            return _context4.abrupt("return", _this._request(path, requestParams));
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }());
  _defineProperty(this, "_request", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(path, request) {
      var race;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            race = Promise.race([timeout(_this.API_TIMEOUT), isomorphicFetch("".concat(_this.apiUrl).concat(path), request)]);
            return _context5.abrupt("return", race.then(checkStatus(_this.notifyError))
            // eslint-disable-next-line no-use-before-define
            .then(getResponseBody(request))["catch"](_this.onError));
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }());
  var config = _objectSpread(_objectSpread({}, defaultConfig), compact(fields.reduce(function (cfg, fieldName) {
    return _objectSpread(_objectSpread({}, cfg), {}, _defineProperty({}, fieldName, _options[fieldName]));
  }, {})));
  Object.assign(this, config, services);
  // eslint-disable-next-line no-use-before-define
  this.bindChildren = bindChildren.bind(this);
  this.bindChildren(this);
  this.headers = _options.headers;
});
function getRequestBody(_ref6) {
  var request = _ref6.request,
    requestHeaders = _ref6.headers,
    _ref6$options = _ref6.options,
    options = _ref6$options === void 0 ? {} : _ref6$options;
  var headers = _objectSpread(_objectSpread({}, baseHeaders), requestHeaders);

  // eslint-disable-next-line no-use-before-define
  if (hasPayload(request)) {
    headers = _objectSpread(_objectSpread({}, postHeaders), headers);
    var body;

    // is json api adapter?
    if (options.isData) {
      body = JSON.stringify({
        data: {
          type: options.type,
          attributes: request.body
        }
      });
    } else {
      body = JSON.stringify(request.body);
    }
    return _objectSpread(_objectSpread({}, request), {}, {
      body: body,
      headers: headers
    });
  }
  return _objectSpread(_objectSpread({}, request), {}, {
    headers: headers
  });
}
function hasPayload(_ref7) {
  var method = _ref7.method;
  return _.includes(['POST', 'PUT', 'PATCH'], method);
}
function bindChildren(obj, parentKey) {
  var that = this;
  _.forIn(obj, function (val, key) {
    if (_.isObject(val)) {
      that.bindChildren(obj[key], key);
    }
    if (key && parentKey) {
      that[parentKey][key] = that[parentKey][key].bind(that);
    }
  });
}
function getResponseBody(req) {
  var method = req.method;
  return function (response) {
    if (method === 'DELETE' || response.status === 204) {
      return response.text();
    }
    return response.json();
  };
}

export { ArgumentMissingError, TimedOutError, Client as default };
